import { GremlinNode } from '../nodes/gremlinNode';
import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'sv-node-edit',
  template: `<h2 mat-dialog-title>Edit Node</h2>
<mat-dialog-content>
	<div fxLayout fxLayoutAlign="start center" fxLayoutGap="1em">
		<mat-input-container>
			<mat-select [(ngModel)]="data.item.label" placeholder="Label">
				<mat-option *ngFor="let item of data.labels" [value]="item">{{item}}</mat-option>
			</mat-select>
		</mat-input-container>
		<div>
			<button mat-raised-button (click)="createProperty()"><mat-icon>add</mat-icon>Add Property</button>
		</div>
	</div>
	
	
	<div fxLayout fxLayoutGap="1em" *ngFor="let item of data.item.properties">
		<mat-input-container>
			<input matInput placeholder="property name" [(ngModel)]="item.key">
		</mat-input-container>
		<mat-input-container>
			<input matInput placeholder="property value" [(ngModel)]="item.value">
		</mat-input-container>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-button mat-dialog-close>Cancel</button>
	<!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
	<button mat-button [mat-dialog-close]="data.item">Confirm</button>
</mat-dialog-actions>`,
  styles: [``]
})
export class NodeEditComponent implements OnInit {

  createProperty() {
    this.data.item.properties.push({key: '', value: ''});
  }

  constructor(
    public dialogRef: MatDialogRef<NodeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
  }

}
